import { render } from "./LesPublicationsPage.vue?vue&type=template&id=a815d7d2"
import script from "./LesPublicationsPage.vue?vue&type=script&lang=js"
export * from "./LesPublicationsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__